import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import LoginForm from '../components/LoginForm';
import ActivityIndicator from '../components/ActivityIndicator';
import { loginAsAdmin } from '../services/authService';

const LoginPage = () => {
  const [loading, setLoading] = useState(false);
  const [checkingAuth, setCheckingAuth] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      navigate('/', { replace: true });
    } else {
      setCheckingAuth(false);
    }
  }, []);

  if (checkingAuth) return <ActivityIndicator />

  const handleLogin = async (credentials) => {
    setLoading(true);
    const result = await loginAsAdmin(credentials.username, credentials.password);
    setLoading(false);

    if (result.success) {
      navigate('/');
    } else {
      toast.error(result.message);
    }
  };

  return (
    <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
      {
        checkingAuth ?
          <ActivityIndicator /> :
          <Row className="w-100 justify-content-center">
            <Col md={6} lg={4}>
              <Card>
                <Card.Body>
                  <h3 className="text-center mb-4">Login</h3>
                  <LoginForm onSubmit={handleLogin} loading={loading} />
                </Card.Body>
              </Card>
            </Col>
          </Row>
      }
      
    </Container>
  );
};

export default LoginPage;
